import { createError } from '../utils/background/Utils';

interface ApiErrorParams {
    message?: string;
    method?: string;
    route?: string;
    body?: object | string | number | boolean | null;
    status?: number;
}

const ApiError = createError({
    name: 'ApiError',
    message: (p: ApiErrorParams) => p.message ?? 'Api error',
    fingerprint: (p: ApiErrorParams) => [`${p.method}:${p.route}`],
    extra: (p: ApiErrorParams) => ({
        type: 'ApiError',
        debugInfo: p.body || {},
        meta: p.method,
        route: p.route,
        status: p.status
    }),
    status: (p: ApiErrorParams) => p.status
});

export const Network = { ApiError };
